import { Button } from 'components/Button/Button';
import type {
  ConfigurationData,
  TabData,
} from 'components/DeviceView/deviceViewTypes';
import { useLocale } from 'containers/App/LocaleContext';
import { type FC, memo } from 'react';

interface Props {
  configurationDownloading: boolean;
  onDownloadConfiguration: () => void;
  tabData: TabData;
}

export const isConfigurationAvailable = (
  configuration: ConfigurationData | undefined,
): configuration is ConfigurationData =>
  !!configuration && !!configuration.hash;

const BareDeviceViewContentConfigurationButton: FC<Props> = (props) => {
  const msg = useLocale();
  const { tabData } = props;

  if (!props.tabData) {
    return null;
  }

  if (isConfigurationAvailable(tabData.configuration)) {
    return (
      <Button
        className='mr-4'
        onClick={() => {
          props.onDownloadConfiguration();
        }}
        variant='tertiary'
        icon='fa-file-code'
        loading={props.configurationDownloading}
        type='button'
      >
        {msg.deviceView.btnConfigFile}
      </Button>
    );
  }
  return null;
};

export const DeviceViewContentConfigurationButton = memo(
  BareDeviceViewContentConfigurationButton,
);
